// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__GZFNr","inputWrap":"CustomTip_inputWrap__2NrMy"};